import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import SearchFeedRetry from './SearchFeedRetry';

const NOOP = () => {};

export default function RandomizedHomeLinksList({
  className,
  randomizedState,
  emptyText,
  VirtualListComponent,
  virtualListProps = {},
  emptyTextClassName,
  children = null,
}) {
  if (!VirtualListComponent) {
    return null;
  }

  return (
    <div className={className}>
      {children}
      {randomizedState.loading ? (
        <Loader />
      ) : randomizedState.data.length === 0 ? (
        <>
          {!randomizedState.error && (
            <Text className={emptyTextClassName} paragraph>{emptyText}</Text>
          )}
          <SearchFeedRetry error={randomizedState.error} onRetry={randomizedState.retry} />
        </>
      ) : (
        <>
          <VirtualListComponent
            items={{
              data: randomizedState.data,
              totalDocs: randomizedState.error
                ? randomizedState.data.length
                : randomizedState.listLengthHint ?? randomizedState.data.length,
            }}
            onLoadMore={randomizedState.loadMore ?? NOOP}
            {...virtualListProps}
          />
          <SearchFeedRetry error={randomizedState.error} onRetry={randomizedState.retry} />
        </>
      )}
    </div>
  );
}
